import type { Session } from '../lib/auth'
import { navigate } from '../hooks/useHashRoute'
import { MANUAL_URL } from '../../shared/site-config'

type HeaderProps = {
  session: Session | null
  onLogout: () => void
}

export default function Header({ session, onLogout }: HeaderProps) {
  return (
    <header className="site-header">
      <button className="brand-button" onClick={() => navigate('home')}>
        <span className="brand-mark">D</span>
        <span>DSM Editor</span>
      </button>

      <nav aria-label="주요 메뉴">
        <button onClick={() => navigate('home')}>소개</button>
        <button onClick={() => navigate('keyword-tool')}>키워드 통계</button>
        <button onClick={() => navigate('resources')}>다운로드</button>
        <a href={MANUAL_URL} target="_blank" rel="noreferrer">사용 설명서</a>
      </nav>

      <div className="header-account">
        {session ? (
          <>
            <span className="account-name">{session.username}</span>
            <button className="button button-ghost button-small" onClick={onLogout}>
              로그아웃
            </button>
          </>
        ) : (
          <button className="button button-primary button-small" onClick={() => navigate('login')}>
            로그인
          </button>
        )}
      </div>
    </header>
  )
}
